import React from 'react';
;
const PrimaryButton = ({ primaryBtnClassName, primaryBtnIcon, primaryBtnIconClassName, onClick, btnType, btnTextOverride, }) => (React.createElement("button", Object.assign({ className: primaryBtnClassName || '' }, (onClick && { onClick }), { type: btnType }),
    btnTextOverride || 'Continue',
    primaryBtnIcon && (React.createElement("span", { className: primaryBtnIconClassName || '' }, primaryBtnIcon))));
export default PrimaryButton;
//# sourceMappingURL=PrimaryButton.js.map